import { render, staticRenderFns } from "./ShoppingCartDetails.vue?vue&type=template&id=94acc58e"
import script from "./ShoppingCartDetails.vue?vue&type=script&lang=js"
export * from "./ShoppingCartDetails.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCartDetails.vue?vue&type=style&index=0&id=94acc58e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports